/** Statuts qui ne bloquent pas la création d’un nouveau cas (ni comptés comme actifs). */
export const NON_BLOCKING_CASE_STATUSES = new Set(['draft', 'cancelled', 'archived']);

/**
 * Conception « active » : même règle que CreateCaseModal (blocage doublon).
 * @param {{ status?: string, current_phase?: string }} caseRow
 */
export function isActiveCase(caseRow) {
  if (!caseRow) return false;
  const status = caseRow.status;
  const isShippingCompleted =
    status === 'completed' && caseRow.current_phase === 'delivered';
  const isNonBlocking = NON_BLOCKING_CASE_STATUSES.has(status);
  return !isShippingCompleted && !isNonBlocking;
}

/** @param {Array<{ status?: string, current_phase?: string }>} cases */
export function countActiveCases(cases) {
  return (cases || []).filter(isActiveCase).length;
}

/** Agrège le nombre de cas actifs par patient_id. */
export function activeCaseCountByPatientId(cases) {
  const map = new Map();
  for (const row of cases || []) {
    if (!row?.patient_id || !isActiveCase(row)) continue;
    map.set(row.patient_id, (map.get(row.patient_id) || 0) + 1);
  }
  return map;
}
